import { useState } from 'react';
import { Box, CssBaseline } from '@mui/material';
import Topbar from './Topbar';
import Sidebar from './navBar/index';

const expandedWidth = 215;
const collapsedWidth = 50;

const Layout = ({ children, onLogout }) => {
  
  const [collapsed, setCollapsed] = useState(() => {
  try {
    const stored = localStorage.getItem("sidebarCollapsed");
    // Parse only if stored is not null/undefined and not the string "undefined"
    return stored && stored !== "undefined" ? JSON.parse(stored) : false;
  } catch (e) {
    console.error("Error parsing sidebarCollapsed from localStorage:", e);
    return false;
  }
});


  const drawerWidth = collapsed ? collapsedWidth : expandedWidth;
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh', overflow: 'hidden' }}>
      <CssBaseline />

      {/* Topbar */}
     
      <Topbar onToggleNav={() => setCollapsed(!collapsed)} />

      {/* Content row (Sidebar + Main Content) */}
      <Box sx={{ display: 'flex', flexGrow: 1 }}>

        {/* Sidebar */}
        <Sidebar open={true} collapsed={collapsed} setCollapsed={setCollapsed} drawerWidth={drawerWidth} onLogout={onLogout} />

        {/* Main content */}
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            mt: "51px",
            bgcolor: 'background.default',
            overflowY: 'auto',
            height: 'calc(100vh - 64px)', // assuming topbar height is 64px
            transition: 'width 0.3s ease',
          }}
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
};

export default Layout;







